import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { ImgAddorupdateComponent } from '../img-addorupdate/img-addorupdate.component';
declare var $;
@Component({
  selector: 'app-img-list',
  templateUrl: './img-list.component.html',
  styleUrls: ['./img-list.component.css']
})
export class ImgListComponent implements OnInit {
  // 素材Id
  @Input() materialId: any;
  // 删除弹框对象
  @Input() trim:any;
  // 点击图像跳转到指定页：抛出事件
  @Output() toPage = new EventEmitter(); 
  // 图像名称
  key = '';
  // 图像数据
  imgs:any = [];
  // 分页参数
  pageBase: any = {
      current: 1,
      size: 6
  };
  constructor(
    private create: SwCreateModalComponentService,
    private box: SwMassageBoxService,
    private kmsService: KmsService
  ) { }

  ngOnInit() {
    // 查询已标注的图像信息
    this.clickSearch();
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.clickSearch();
    }
  }

  // 搜索
  clickSearch(){
    this.pageBase = {
      current: 1,
      size: 6
    }
    this.getData();
  }

  //获取数据
  getData() {
    const params = {
      'name': $.trim(this.key),
      'current': this.pageBase.current,
      'size': this.pageBase.size,
      'parentMaterialId': this.materialId,
	    'relType': 1,  // 1 图像  2 表格
    }
    this.kmsService.queryPicTableList(params).subscribe(
      data => {
        if (data.code == '200') {
          this.pageBase = data.data;
          this.imgs = data.data.records;
          this.imgs.forEach(el => {
            el.src = environment.staticFileUrl+el.fileThumbnail;
          })
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 重置
  clickReload(){
    this.key = '';
    this.clickSearch();
  }

  // 选择图像
  selectImg(item){
    this.toPage.emit(item.pagesNum);
  }

  // 新增图像
  clickAddImg(){
    let params = {
      upOrAdd: 'Add',
      materialRelId: '',
      materialId: this.materialId
    };
    this.create.createModal(ImgAddorupdateComponent, params, this.clickSearch.bind(this));
  }

  // 编辑图像
  clickEditImg(materialRelId) {
    let params = {
        upOrAdd: 'Edit',
        materialRelId: materialRelId,
        materialId: this.materialId
    };
    this.create.createModal(ImgAddorupdateComponent, params, this.clickSearch.bind(this));
  }

  // 删除图像
  clickDeleteImg(materialRelId) {
    this.trim.openCLick('是否删除当前图像？', (data) => {
        if (data) {
            let ids = [materialRelId];
            this.kmsService.delteMaterialRelById(ids).subscribe(
                data => {
                    if (data.code == '200') {
                        this.box.success('删除成功！');
                        this.clickSearch();
                    } else {
                        this.box.waring(data.msg);
                    }
                }
            );
        }
    });
  }

  // 图像标记
  clickImgMark(item) {

  }

  // 分页点击方法
  clickPageQuery(event) {
    this.pageBase = event;
    this.getData();
  }

}
